module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_3009.cbaf1042.png";